module.exports = __webpack_public_path__ + "img/PaperPlane_Vector.429359c3.svg";